export const l = {
    hebewallet:"Secure cryptocurrency wallet for Bitcoin, Ethereum, Ripple, Litecoin, Stellar，Nxt，Arodr and over 90 main chains",
    fhead:{
        'zh-CN':'中文',
        'en-US':'English',
        block:'Explorer',
        blocks:'Block',
        peers:'Peers',
        generators:'Generator',
        peersMap:'PeersMap',
        peers3d:'Peers3d',
        prompt:{
            title:'prompt',
            txt:'Please enter the Address / Height / Tsransaction',
            confirm:'Ok',
            cancel:'Cancel'
        },
        peer1:"Node operation",
        peer2:"Mortgage node"
    },
    accountCount: 'Accounts total',
    assetCount: 'Asset total',
    currencyCount: 'Currency Total',
    aliasCount: 'Alias Total',
    block: 'Block',
    senderRS: 'Send address',
    recipientRS: 'Receive address',
    amountNQT: 'Amount',
    feeNQT: 'Fee',
    height: 'Height',
    timestamp: 'Date',
    totalAmountNQT: 'Amount',
    transactionsLength: 'Number',
    generatorRS: 'GeneratorRS',
    generators: 'Generators',
    generators1: 'Generators Number of people',
    generators2: 'Not all generators Number of people',
    lessorRS: 'lessorRS',
    guaranteedBalanceNQT: 'Rental quantity',
    accountRS: 'AccountRS',
    effectiveBalance: 'Forging quantity',
    lessorSum: 'Number of lessors',
    lessorTimes: 'Block time',
    deadline: 'Countdown time',
    home: 'Home',
    hour:'',
    peers: {
        txt1: "Current peer-to-peer network",
        txt2: "Not all network nodes",
        address: 'IP address',
        version: 'Version',
        platform: 'Platform',
        services: 'Services',
        lastUpdated: 'LastUpdated'
    },
    account: {
        addr: 'Address',
        this: 'This account',
        id: 'ID',
        name: 'Name',
        publicKey: 'PublicKey',
        balanceNQT: 'Balance',
        lessorsSum: 'Lessors',
        forgedBalanceNQT: 'Forged amount',
        blockCount: 'Forged blocks',
        description: 'Account description',
        currentLesseeTitle:'Rental information',
        currentLessee:'Tenant account ID',
        currentLesseeRS:'Tenant account address',
        currentLeasingHeightFrom:'Rental height',
        currentLeasingHeightTo:'Expiration height',
        nextLessee:'Next Lessee',
        nextLesseeRS:'Next LesseeRS',
        nextLeasingHeightFrom:'NextLeasing Height From',
        nextLeasingHeightTo:'Next Leasing Height To',
        add15:'Load 15 more messages',
        transaction:'Transaction information list',
        date:'Date',
        lessorsTitle:'Lessors List',
        blockCountTitle:'Forged block list',
        pow:'POW forged block list',
        index:{
            title:'All accounts',
            title1:'Account list',
            BALANCE:'Number of coins held',
            FORGED_BALANCE:'Forging income',
            DESCRIPTION:'description'
        }
    },
    alias:{
        title:'All aliases',
        title1:'Alias list',
        search:'Please enter a search alias',
        ALIAS_NAME:'Name',
        accountRS:'Owner'
    },
    asset:{
        title:'All assets',
        title1:'Asset list',
        search:'Please enter a search asset',
        account:'Asset ID',
        NAME:'Asset Name',
        INITIAL_QUANTITY:'Initial quantity',
        QUANTITY:'Quantity',
        DECIMALS:'Decimal point',
        accountRS:'Issuer'
    },
    currency:{
        title:"All currency",
        title1:'Currency List',
        search:'Please enter the search currency',
        account:'Currency id',
        NAME:'Currency Name',
        MAX_SUPPLY:'Max supply',
        accountRS:'Issuer'
    },
    blocks:{
        title:'All blocks',
        totalAmountNQT:'Total transfer amount',
        date:'Date'
    },
    blockIndex:{
        title:'All blocks',
        title1:'Block height',
        title2:'Next block',
        title3:'Previous block',
        transactions:'Transaction information list',
        height:'Block height',
        date:'Block time' ,
        generatorRS:'GeneratorRS',
        length:'Number',
        totalAmountNQT:'Amount',
        totalFeeNQT:'Fee'
    },
    transaction:{
        height:"Height",
        block:"Block",
        senderRS: 'Send address',
        amountNQT:"Amount",
        feeNQT:"Fee",
        recipientRS: 'Receive address',
        timestamp:"Date",
        confirmations:"Confirmations",
        attachment:"Attachment"
    },
    peer: {
        txt: "Mortgage node",
        txt1: "Add node",
        txt2: "Ip address",
        txt3: "Owner",
        txt4: "Date",
        txt5: "Reward coins",
        txt6: "Mortgage",
        txt7: "Server",
        txt8: "Last online time",
        txt9: "Please use http://block.hebeblock.com domain name, you cannot use https to get data normally",
        txt10: "Node type",
        txt11: "Please select the node type",
        txt12: "Server node",
        txt13: "Local node",
        txt14: "Node ip",
        txt15: "Please enter the remote node ip",
        txt16: "Check",
        txt17: "Click check",
        txt18: "Node ip",
        txt19: "Hebe addr",
        txt20: "Last",
        txt21: "Create",
        txt22: "Cancel",
        txt23: "Prompt",
        txt24: "Ok",
        txt25: "Obtaining information error, the local node is not yet associated with the remote node, please wait",
        txt26: "The remote server does not open port 8082",
        txt27: "Remote server request error",
        txt28: "Get information error, please check whether your local node is started",
        txt29: "Obtaining information error, there is a problem with the remote node",

    }

}



// WEBPACK FOOTER //
// ./src/lang/en.js